// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const EndOfLifeIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      d="m20.83 8.1-4.94-4.93a.6.6 0 0 0-.4-.17H8.51a.6.6 0 0 0-.42.17L3.17 8.11a.6.6 0 0 0-.17.4v6.97a.6.6 0 0 0 .17.44l4.93 4.9a.6.6 0 0 0 .42.18h6.96a.6.6 0 0 0 .41-.18l4.94-4.9a.6.6 0 0 0 .17-.44V8.52a.6.6 0 0 0-.17-.41m-1.33 6.72a.7.7 0 0 1-.2.5l-3.99 3.97a.7.7 0 0 1-.5.2H9.19a.7.7 0 0 1-.5-.2L4.7 15.32a.7.7 0 0 1-.2-.5V9.18a.7.7 0 0 1 .2-.5L8.68 4.7a.7.7 0 0 1 .5-.2h5.93l4.19 4.19q.2.2.2.5zm-7.51.18a.75.75 0 1 0 .01 0zm0-7.51a.75.75 0 0 0-.75.74v5.27a.75.75 0 1 0 1.5 0V8.25A.75.75 0 0 0 12 7.5z"
      clipRule="evenodd"
    />
  </svg>,
  "EndOfLife",
);
export default EndOfLifeIcon;
